// extracted by mini-css-extract-plugin
export default {"section":"AddingIngredients_section__UoqW6","step":"AddingIngredients_step__HbmCb"};